.status-bar {
  max-height: 150px;
  overflow-y: auto;
}

.status-bar > div {
  border-width: 1px 0;
  border-style: solid;
  padding: 2px 10px;
}

.message {
  display: flex;
  align-items: center;
}

.message-icon svg {
  margin-right: 10px;
  fill: var(--main-text);
  display: flex;
  width: 1.5rem;
}

.message-title {
  margin-right: 10px;
  vertical-align: middle;
  font-weight: 700;
}

.message-text {
  vertical-align: middle;
}

.info {
  background-color: #dee9f7 !important;
  border-color: #a6baf5 !important;
}

.warning {
  background-color: #fff19d !important;
  border-color: #d7d889 !important;
}

.error {
  background-color: #f8d4d4 !important;
  border-color: #f5a6a7 !important;
}

.success {
  background-color: #c7f299 !important;
  border-color: #99cc62 !important;
}
